import React, { FC } from 'react'

const RulesLink: FC = () => (
    <a className='rules-link result__rules' href='/rules_09_04.pdf' target='_blank'>Правила акции</a>
)

export default RulesLink
